import { syncServerClock } from './clock'
// Leveled client-side logger for the dashboard. The threshold comes from the
// backend (GET /api/config -> logLevel), so it is configurable per deploy via the
// FRONTEND_LOG_LEVEL / LOG_LEVEL env on the web-server backend, without a rebuild.
// At "debug" the WS payloads we receive are printed to the console; nginx access
// and error logs of this container are shipped to Loki by the host Alloy agent.
const LEVELS = { debug: 10, info: 20, warn: 30, error: 40 }

let threshold = LEVELS.info

// initLogLevel fetches the configured level once. Until it resolves the logger
// stays at "info". Best-effort, never throws.
export function initLogLevel() {
  return fetch('/api/config')
    .then(r => r.json())
    .then(cfg => {
      setLogLevel(cfg?.logLevel)
      // A mesma resposta carrega o relógio do servidor, e o alinhamento tem que
      // existir antes do primeiro render: a tela de equipamentos decide o estado da
      // frota comparando instantes do servidor com o "agora", e o WebSocket, que é a
      // outra fonte do alinhamento, abre depois.
      syncServerClock(cfg?.serverTime)
    })
    .catch(() => {})
}

export function setLogLevel(level) {
  if (level && LEVELS[level] != null) threshold = LEVELS[level]
}

function emit(level, method, args) {
  if (LEVELS[level] >= threshold) console[method](`[${level}]`, ...args)
}

export const log = {
  debug: (...a) => emit('debug', 'debug', a),
  info: (...a) => emit('info', 'info', a),
  warn: (...a) => emit('warn', 'warn', a),
  error: (...a) => emit('error', 'error', a),
}
